/* eslint-disable global-require */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import globalLogoImg from 'Assets/img/global-payments-logo.png';
import Button from 'Components/Button';
import AppDrawerIcon from 'Components/icons/DrawerIcon/AppDrawerIcon';
import { connect } from 'react-redux';import './SiteHeader.scss';
import UserAvatarIcon from '../../../../dims-common-ui/components/icons/BIDashboard/UserAvatarIcon/UserAvatarIcon';
import { getEnv } from 'Utils/featureFlagUtils';
export class SiteHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuClicked: false,
      openMobileNav: false,
      isDrawerOpen: false,
      isSecondaryDrawerOpen: false,
      isToggledSiteHeaderExitModal: false,
      drawerIsExtended: false,
      showSupportAccessPanel: false,
      role: JSON.parse(sessionStorage.getItem('state')).auth.user.role.key,
      acquirerCode:JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
      userPermission:JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions,
      externalUsers:['DiMS_ACCOUNT_ADMIN', 'DiMS_ACCOUNT_USER','DiMS_ACQUIRER_ADMIN','DiMS_ACQUIRER_USER','DiMS_HPY_ACCOUNT_USER'],
      userAcquirerCode : sessionStorage.getItem("userAcquirerCode")
    };

    this.attachBindings();
    this.firstClick = true;
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.closeMenu);
  }

  componentWillUnmount() {
    clearInterval(this.supportPollingInterval);
    document.removeEventListener('mousedown', this.closeMenu);
  }

  openMenu() {
    if (this.firstClick) {
      this.setState({ menuClicked: true }, () => {
        this.firstClick = false;
      });
    } else {
      this.setState({ menuClicked: false }, () => {
        this.firstClick = true;
      });
    }
  }

  toggleMobileNav() {
    this.setState({ openMobileNav: !this.state.openMobileNav });
  }


  closeMenu(event) {
    if (
      (this.header && !this.header.contains(event.target)) ||
      (event.target.classList[0] &&
        (event.target.classList[0].indexOf('global-selector') > -1 ||
          event.target.classList[0].indexOf('mobile-hidden') > -1))
    ) {
      this.setState(
        {
          menuClicked: false,
        },
        () => {
          this.firstClick = true;
        },
      );
    }
  }

  attachBindings() {
    this.closeMenu = this.closeMenu.bind(this);
    this.logout = this.logout.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.toggleMobileNav = this.toggleMobileNav.bind(this);
    this.toggleExitModal = this.toggleExitModal.bind(this);
    this.openAppDrawer = this.openAppDrawer.bind(this);
  }
  
  logout() {
    this.setState({ menuClicked: false });
    this.props.history.push('/logout');
  }

  openAppDrawer() {
    let url = this.props.location.pathname;
    if(!this.props.showLogo){
      this.props.history.goBack();
    }
    if (url === '/') {
      url = '/application';
    } else if (url.indexOf('/application') === -1) {
      if(url.includes('queue-management-landing')){
       url = `${this.props.location.pathname + this.props.location.search}&application`;
     }else{
        url = `${this.props.location.pathname + this.props.location.search}/application`;
     }
     }
    this.props.history.push(url);
  }

  toggleExitModal() {
    this.setState({
      isToggledExitModal: !this.state.isToggledExitModal,
    });
  }


  get userLink() {
    const userName = (this.props.auth !== undefined && this.props.auth.user && this.props.auth.user.firstName ? this.props.auth.user.firstName.charAt(0).toUpperCase() : 'Global') +
      (this.props.auth !== undefined && this.props.auth.user && this.props.auth.user.lastName ? this.props.auth.user.lastName.charAt(0).toUpperCase() : 'Admin');
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={this.openMenu}
        className="user-menu"
      >
        <UserAvatarIcon userName={userName} 
          isMenuExpand={this.state.menuClicked}
         />
      </div>
    );
  }

  get appDrawerButton() {
    const token = sessionStorage.getItem("state") ? JSON.parse(sessionStorage.getItem("state")).auth.accessToken : '';
    const brand = sessionStorage.getItem("appPortal");
    const env = getEnv(window.location.hostname);
    return (
      <app-tray 
        token={token} 
        brand={brand}
        env={env === 'prod' ? 'prd' : env}
        size="small"
        class="app-tray"
      ></app-tray>

    );
  }

  render() {
    return (
      <div className="site-header-container">
        <header
          className="global-actions"
          role="button"
          tabIndex={0}
          style={this.props.headerStyle}
        >
          <div
            ref={(ref) => (this.header = ref)}
            className="mobile-hidden desktop-navigation"
          >
            <div className="site-header__right"  style={this.props.loginBoxStyle} >
              {this.state.menuClicked && (
                <div className="user-submenu">
                  <div className="profile-buttons">
                    <div className="button button-link profile-button">
                      <span className="profile-avatar">{this.props.auth !== undefined && this.props.auth.user.firstName.charAt(0).toUpperCase() + this.props.auth.user.lastName.charAt(0).toUpperCase()}</span>
                      <span className="profile-details">
                        <span className="profile-name">{this.props.auth !== undefined && this.props.auth.user.firstName + ' ' + this.props.auth.user.lastName}</span>
                        <span className="profile-role">{this.props.auth !== undefined && this.props.auth.user.role.name}</span>
                      </span>
                    </div>
                  </div>
                  <Button extraClass="logout-button" action={this.logout}>
                    Logout
                  </Button>
                </div>
              )}
              <div className="site-header__right">
                {this.appDrawerButton}
              </div>
              {this.userLink}
            </div>
          </div>
        </header>

      </div>
    );
  }
}

SiteHeader.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isDrawerActive: PropTypes.bool,
  showLogo: PropTypes.bool

};

const mapStateToProps = (state) => ({
  auth: state.auth || {},
  isDrawerActive: state.drawer.isDrawerActive,
  showLogo:true
});

export default withRouter(connect(mapStateToProps)(SiteHeader));
/* eslint-enable global-require */

